import React from 'react';
import { Heading, Box,Image ,Button,Flex,Text,Link} from "@chakra-ui/react";

const ProjectSmall = ({head,detail,img,deploy,github}) => {
  return (
    <div>
        <Box  m="auto" w="80%" p="1rem">
        <Box border="3px solid black">
          <Image src={img} w="100%"/>
        </Box>
        <Box bg="rgb(239, 202, 188)" color="black" p="2rem" borderRight="3px solid orangered" borderLeft="3px solid orangered">
          <Heading fontSize={"3xl"}>{head}</Heading>
          <Text>{detail}</Text>
          <Flex justifyContent="space-around" >
            <Link hrf={deploy}>
            <Button  background="orangered"
              color="white"
              _hover={{
                background: "white",
                color: "orangered",
                border: "1px solid orangered",
              }}>See Live</Button>
              </Link>
              <Link href={github}>
            <Button  background="orangered"
              color="white"
              _hover={{
                background: "white",
                color: "orangered",
                border: "1px solid orangered",
              }}>See Code</Button>
              </Link>
          </Flex>
        </Box>
        <Box bg="orangered" color="ornagered" border="2px solid orangered"></Box>
        
      </Box>
    </div>
  )
}

export default ProjectSmall